import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <h2 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#1a365d', marginBottom: '0.75rem', borderBottom: '2px solid #bee3f8', paddingBottom: '0.4rem' }}>{title}</h2>
    <div style={{ color: '#4a5568', lineHeight: '1.8', fontSize: '0.97rem' }}>{children}</div>
  </div>
);

const li = { marginBottom: '0.4rem' };

const TermsUz = () => (
  <>
    <div style={{ marginBottom: '2rem' }}>
      <a href="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Бош саҳифа</a>
      <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>Ҳизмат кўрсатиш шартлари</h1>
      <p style={{ color: '#718096', fontSize: '0.9rem' }}>Охирги янгиланган: 17 апрел 2025 йил</p>
    </div>
    <p style={{ color: '#4a5568', lineHeight: '1.8', marginBottom: '2rem' }}>
      Ушбу Ҳизмат кўрсатиш шартлари <strong>AdvokatTop</strong> (advokattop.uz) платформасидан фойдаланиш қоидаларини белгилайди. Платформага кириш ёки рўйхатдан ўтиш орқали сиз ушбу шартларга тўлиқ розилик берасиз.
    </p>
    <Section title="1. Платформа тўғрисида">
      <p>AdvokatTop — мижозларни Ўзбекистон адвокатлари билан боғловчи рақамли платформа.</p>
      <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
        <li style={li}>Амалиёт соҳаси ва жойлашув бўйича адвокат излаш;</li>
        <li style={li}>Пулли онлайн-маслаҳат сўрови юбориш;</li>
        <li style={li}>Адвокатлар учун обуна тизими.</li>
      </ul>
      <p style={{ marginTop: '0.75rem' }}><strong>Муҳим:</strong> AdvokatTop фақат мижозлар ва адвокатлар ўртасида алоқа ўрнатувчи воситадир.</p>
    </Section>
    <Section title="2. Рўйхатдан ўтиш ва аккаунт">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Платформадан тўлиқ фойдаланиш учун рўйхатдан ўтиш талаб этилади;</li>
        <li style={li}>Тақдим этган маълумотларнинг аниқлиги учун шахсан жавоб берасиз;</li>
        <li style={li}>Аккаунт маълумотларингизни сир сақлаш мажбуриятингиздир;</li>
        <li style={li}>Бир шахс фақат битта аккаунт очиши мумкин;</li>
        <li style={li}>18 ёшга тўлмаган шахсларнинг рўйхатдан ўтиши тақиқланган.</li>
      </ul>
    </Section>
    <Section title="3. Адвокатлар учун шартлар">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Амалдаги адвокатлик гувоҳномасига ва тегишли лицензиясига эга бўлиши шарт;</li>
        <li style={li}>Гувоҳнома рақами ва берилган сана тўғри кўрсатилиши керак;</li>
        <li style={li}>Профилдаги маълумотлар ҳақиқатга мос бўлиши керак;</li>
        <li style={li}>Обуна тўлови қайтарилмайди.</li>
      </ul>
    </Section>
    <Section title="4. Мижозлар учун шартлар">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Маслаҳат сўровини юборишдан олдин тўлов амалга оширилади;</li>
        <li style={li}>Тўлов ўтказилгандан сўнг пулни қайтариш мумкин эмас (адвокат жавоб беролмаган ҳолат бундан мустасно);</li>
        <li style={li}>Платформадан олинган маслаҳат маълумотлар мақсадида бўлиб, қонуний шартномани алмаштирмайди.</li>
      </ul>
    </Section>
    <Section title="5. Тўлов ва нархлар">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Тўловлар Payme ёки Click орқали қабул қилинади;</li>
        <li style={li}>Барча нархлар сўм (UZS) валютасида кўрсатилади;</li>
        <li style={li}>Тўлов амалга оширилмаса, сўров юборилмайди.</li>
      </ul>
    </Section>
    <Section title="6. Тақиқланган хатти-ҳаракатлар">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Бошқа шахс номидан рўйхатдан ўтиш;</li>
        <li style={li}>Платформага зарар етказувчи техник усулларни қўллаш;</li>
        <li style={li}>Платформадан рекламавий спам ёки фирибгарлик мақсадида фойдаланиш;</li>
        <li style={li}>Адвокатлик гувоҳномасини сохта кўрсатиш;</li>
        <li style={li}>Платформа контентини рухсатсиз нусхалаш.</li>
      </ul>
    </Section>
    <Section title="7. Жавобгарликни чеклаш">
      <p>AdvokatTop платформаси адвокат берган маслаҳатнинг тўғрилиги ёки натижаси учун жавобгар эмас.</p>
    </Section>
    <Section title="8. Интеллектуал мулк">
      <p>Платформадаги барча контент AdvokatTop'га тегишли ва муаллифлик ҳуқуқи билан ҳимояланган.</p>
    </Section>
    <Section title="9. Боғланиш">
      <p><strong>Email:</strong> alis.ergashev@gmail.com<br /><strong>Сайт:</strong> advokattop.uz</p>
    </Section>
  </>
);

const TermsRu = () => (
  <>
    <div style={{ marginBottom: '2rem' }}>
      <a href="/" style={{ color: '#3182ce', fontSize: '0.9rem', textDecoration: 'none' }}>← Главная</a>
      <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#1a365d', marginTop: '1rem', marginBottom: '0.5rem' }}>Условия обслуживания</h1>
      <p style={{ color: '#718096', fontSize: '0.9rem' }}>Последнее обновление: 17 апреля 2025 г.</p>
    </div>
    <p style={{ color: '#4a5568', lineHeight: '1.8', marginBottom: '2rem' }}>
      Настоящие Условия обслуживания регулируют использование платформы <strong>AdvokatTop</strong> (advokattop.uz). Получая доступ к платформе или регистрируясь на ней, вы полностью принимаете настоящие условия.
    </p>
    <Section title="1. О платформе">
      <p>AdvokatTop — цифровая платформа, связывающая клиентов с адвокатами Узбекистана. Предоставляемые услуги:</p>
      <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
        <li style={li}>Поиск адвоката по области практики и местоположению;</li>
        <li style={li}>Отправка платных запросов на онлайн-консультацию;</li>
        <li style={li}>Система подписки для адвокатов.</li>
      </ul>
      <p style={{ marginTop: '0.75rem' }}><strong>Важно:</strong> AdvokatTop является лишь посредником между клиентами и адвокатами. Адвокат несёт личную ответственность за качество предоставленной консультации.</p>
    </Section>
    <Section title="2. Регистрация и аккаунт">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Для полноценного использования платформы требуется регистрация;</li>
        <li style={li}>Вы несёте личную ответственность за точность предоставленных данных;</li>
        <li style={li}>Вы обязаны хранить в тайне данные для входа в аккаунт;</li>
        <li style={li}>Один человек может иметь только один аккаунт;</li>
        <li style={li}>Регистрация лиц младше 18 лет запрещена.</li>
      </ul>
    </Section>
    <Section title="3. Условия для адвокатов">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Адвокат должен иметь действующее адвокатское удостоверение и соответствующую лицензию;</li>
        <li style={li}>Номер удостоверения и дата его выдачи должны быть указаны корректно;</li>
        <li style={li}>Данные в профиле должны соответствовать действительности;</li>
        <li style={li}>Плата за подписку не возвращается после начала использования услуги.</li>
      </ul>
    </Section>
    <Section title="4. Условия для клиентов">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Оплата производится до отправки запроса на консультацию;</li>
        <li style={li}>После оплаты возврат средств невозможен (за исключением случаев, когда адвокат не смог ответить);</li>
        <li style={li}>Консультация, полученная через платформу, носит информационный характер и не заменяет договор об оказании юридических услуг.</li>
      </ul>
    </Section>
    <Section title="5. Оплата и тарифы">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Платежи принимаются через Payme или Click;</li>
        <li style={li}>Все цены указаны в сумах (UZS);</li>
        <li style={li}>Без оплаты запрос не отправляется.</li>
      </ul>
    </Section>
    <Section title="6. Запрещённые действия">
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li style={li}>Регистрация от имени другого лица;</li>
        <li style={li}>Использование программного обеспечения, наносящего вред платформе;</li>
        <li style={li}>Использование платформы для рассылки спама или мошенничества;</li>
        <li style={li}>Предоставление поддельного адвокатского удостоверения;</li>
        <li style={li}>Несанкционированное копирование контента платформы.</li>
      </ul>
    </Section>
    <Section title="7. Ограничение ответственности">
      <p>Платформа AdvokatTop не несёт ответственности за правильность консультации, данной адвокатом, или её результаты.</p>
    </Section>
    <Section title="8. Интеллектуальная собственность">
      <p>Весь контент платформы — логотип, дизайн, тексты, код — принадлежит AdvokatTop и защищён авторским правом.</p>
    </Section>
    <Section title="9. Контакты">
      <p><strong>Email:</strong> alis.ergashev@gmail.com<br /><strong>Сайт:</strong> advokattop.uz</p>
    </Section>
  </>
);

const TermsOfService = () => {
  const { language } = useLanguage();
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem' }}>
        {language === 'ru' ? <TermsRu /> : <TermsUz />}
      </div>
    </div>
  );
};

export default TermsOfService;
